import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TabName } from './effekta.model';
@Injectable({
  providedIn: 'root',
})
export class HoverOverlayService {
  private mySubj = new BehaviorSubject<TabName | undefined>(undefined);

  get activeTab$(): Observable<TabName | undefined> {
    return this.mySubj.asObservable();
  }

  setActiveTab(tabName: TabName) {
    this.mySubj.next(tabName);
  }
}
